(function () {
    'use strict';

    angular
        .module('app')
        .controller('CriticalPathCommercializationEditController', criticalPathCommercializationEditController);

    function criticalPathCommercializationEditController($scope, $http, $sce, $cookies, $location, $window, $rootScope, $filter, $timeout, $interval, $state, $stateParams, ReportService, UserService, ImageUrl, DefaultThumbnailSize, DefaultEnlargeSize, LinePlanService, PatternService, CriticalPathService, cfpLoadingBar, toaster, UserPreferenceService) {
        var model = this;

        $scope.criticalPathCommercializationId = $stateParams.criticalPathCommercializationId;
        $scope.isFactoryUser = $rootScope.isFactoryUser;
        $scope.userId = $rootScope.userId;
        $scope.brandPermissions = $rootScope.brandPermissions;
        $scope.fullName = $rootScope.fullName;
        $scope.currentUser = $rootScope.globals.currentUser

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        model.CriticalPathCommercializationRead = false;
        model.CriticalPathCommercializationEdit = false;
        model.CanEditName = false;

        //check Permissions
        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 13) {
                if (userPermissionRow[1] == 1) {
                    model.CriticalPathCommercializationRead = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.CriticalPathCommercializationEdit = true;
                }
            }
        });

        $scope.poNotes = 'poNotes.html';

        //If user doesnt have Read or Edit, redirect to Permission Denied Page
        if (model.CriticalPathCommercializationRead == false && model.CriticalPathCommercializationEdit == false) {
            $state.go('permissionDenied');
        }

        model.isReadOnly = true;

        if (model.CriticalPathCommercializationRead == true && model.CriticalPathCommercializationEdit == false) {
            model.isReadOnly = true;
        }

        if (model.CriticalPathCommercializationEdit == true) {
            model.isReadOnly = false;
        }

        model.criticalPathCommercializationId = $stateParams.criticalPathCommercializationId;

        model.criticalPathCommercializationData = [];
        model.cpCommercializationProcessesData = [];
        model.cpCommercializationProcessesToDelete = [];

        //UserPreferenceService.getUserPreferences('HeaderMinimized').then(function (response) {
        //    model.headerMinimized = false;
        //    if (response && response.length > 0) {
        //        var userReportModel = eval('(' + response[0].PreferenceValue + ')');
        //        model.headerMinimized = userReportModel.minimized;
        //        model.userPreferenceId = response[0].UserPreferenceId;
        //    }
        //});

        model.minimizeToggle = function () {
            if (model.headerMinimized) {
                model.headerMinimized = false;
            } else {
                model.headerMinimized = true;
            }
            //user preference for minimized
            var userPreferenceModel = {
                UserPreferenceId: model.userPreferenceId,
                PreferenceName: "HeaderMinimized",
                model: angular.toJson({ "minimized": model.headerMinimized }),
                EnsureUnique: true
            }

            UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (response) {
                if (response !== 1) {
                    //change user preference id only when a new one is added
                    model.userPreferenceId = response;
                }
            });
        }

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (idx < 0) { // just in case for whatever reason there is no brand record at all
                $state.go('permissionDenied');
                return;
            }
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        };

        function getFactoryPermissions(factoryKey) {
            if (!$rootScope.isFactoryUser) {
                return;
            }
            UserService.getUserFactories($rootScope.userId).then(function (response) {
                if (!response) {
                    return;
                }
                var idx = response.map(function (e) { return e.FactNameKy }).indexOf(factoryKey);
                if (idx < 0) { //no fatcory record for this user at all
                    $state.go('permissionDenied');
                    return;
                }
                if (!response[idx].IsAssigned) { //for some reason there is a record but the factory is unassigned...
                    $state.go('permissionDenied');
                    return;
                }
            });
        };

        model.commProcessesDataLoading = true;
        function getCriticalPathCommercializationProcesses() {
            CriticalPathService.getCriticalPathCommercializationProcesses(model.criticalPathCommercializationId).then(function (processesResponse) {
                $scope.criticalPathCommercializationProcesses = processesResponse;
                model.commProcessesDataLoading = false;

                angular.forEach($scope.criticalPathCommercializationProcesses, function (k) {
                    k.EstStartDate = $filter('date')(k.EstStartDate, "MM/dd/yyyy");
                    if (k.EstStartDate) {
                        k.CanEditEstStartDate = false;
                    }
                    k.EstEndDate = $filter('date')(k.EstEndDate, "MM/dd/yyyy");
                    if (k.EstEndDate && k.EstEndDate !== null) {
                        k.CanEditEstCompleteDate = false;
                    }
                    k.RevStartDate = $filter('date')(k.RevStartDate, "MM/dd/yyyy");
                    k.RevCompleteDate = $filter('date')(k.RevCompleteDate, "MM/dd/yyyy");
                    k.ApprovalDate = $filter('date')(k.ApprovalDate, "MM/dd/yyyy");
                });
            });
        }
        //getCriticalPathCommercializationProcesses();

        function getCriticalPathCommercializationDetails() {

            model.cpCommercializationProcessesData = [];
            model.cpCommercializationProcessesToDelete = [];
            
            CriticalPathService.getCPCommercializationDetails(model.criticalPathCommercializationId).then(function (commResponse) {
                model.criticalPathCommercializationHeaderDetails = commResponse;

                model.factoryGroupNameAndKey = function () {
                    var f = '';
                    if (model.criticalPathCommercializationHeaderDetails.FactoryGroupName) {
                        f = model.criticalPathCommercializationHeaderDetails.FactoryGroupName
                        if (model.criticalPathCommercializationHeaderDetails.FactoryGroupKey && model.criticalPathCommercializationHeaderDetails.FactoryGroupKey.length > 0) {
                            f += " (" + model.criticalPathCommercializationHeaderDetails.FactoryGroupKey + ")";
                        }
                    }

                    return f;
                }

                getFactoryPermissions(commResponse.FactoryKey);

                PatternService.getPatternDetails(model.criticalPathCommercializationHeaderDetails.PatternId).then(function (patternDetails) {
                    model.patternDetails = patternDetails;

                    getBrandPermissions(model.patternDetails.BrandId);

                    UserService.getUsersByBrand(model.patternDetails.BrandId).then(function (data) {
                        model.users = data;
                    });

                    model.patternImage = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');

                    model.patternImageFull = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');
                });

                CriticalPathService.getStockNumbers(model.criticalPathCommercializationHeaderDetails.PatternId, model.criticalPathCommercializationHeaderDetails.FactoryKey).then(function (stockNumbersResponse) {
                    model.stockNumbers = stockNumbersResponse;
                });

                CriticalPathService.getPatternPurchaseOrders(model.criticalPathCommercializationHeaderDetails.PatternId, model.criticalPathCommercializationHeaderDetails.FactoryKey).then(function (purchaseOrdersResponse) {
                    model.purchaseOrdersData = purchaseOrdersResponse;
                });

                PatternService.getPatternSeasonalDetails(model.criticalPathCommercializationHeaderDetails.PatternSeasonalId).then(function (patternSeasonalResponse) {

                    model.patternSeasonalDetails = patternSeasonalResponse;

                    if (model.patternSeasonalDetails.LinePlanLaunchDateId) {
                        LinePlanService.getLinePlanLaunchDateDetails(model.patternSeasonalDetails.LinePlanLaunchDateId).then(function (linePlanLaunchDateResponse) {
                            model.linePlanLaunchDateDetails = linePlanLaunchDateResponse;
                        });
                    }
                    else {
                        model.linePlanLaunchDateDetails = "";
                    };

                    CriticalPathService.getDevPrototypesForCommercialization(model.criticalPathCommercializationHeaderDetails.CriticalPathCommercializationId).then(function (cpCommDevProtosResponse) {
                        model.cpDevProtos = cpCommDevProtosResponse;
                    });
                });

                CriticalPathService.getCPCommDevPatterns(model.criticalPathCommercializationHeaderDetails.PatternId).then(function (cpDevPatternsResponse) {
                    model.cpDevPatterns = cpDevPatternsResponse;
                });

                CriticalPathService.getCriticalPathProcessApprovedList().then(function (processApprovedData) {
                    model.criticalPathProcessApprovedList = processApprovedData;
                });

            });

            CriticalPathService.getCriticalPathHeaderStatusList().then(function (statusData) {
                model.criticalPathHeaderStatusList = statusData;
            });
        };

        $scope.tableBlur = function (n, o, arr, event) {
            if (arr[o].SortOrder !== arr[o].SortOriginal) {
                event.preventDefault();
                $scope.tableOrder(n, o, arr, event);
            }
        }

        $scope.tableOrder = function (n, o, arr, event, ri) {
            //if this isnt a re-index, dont run this code
            if (!ri) {
                //check the o.r., you like it so far?
                var oArr = arr;
                if (oArr == 'sortableTable1') {
                    arr = $scope.criticalPathCommercializationProcesses;
                }
                //sort the model - only necessary on blur
                var dm = false;
                if (n === true) {
                    dm = arr[o].CriticalPathCommercializationId;
                    arr.sort(function (a, b) {
                        return a.SortOrder - b.SortOrder;
                    });
                } else {
                    //dont do it if there is no old index
                    if (o !== false) {
                        //actually moving the index...
                        var obj = arr[o];
                        arr.splice(o, 1);
                        arr.splice(n, 0, obj);
                    }
                }
            };

            //reindex
            var i = 0;
            angular.forEach(arr, function (k, v) {
                if (dm) {
                    dm === k.CriticalPathCommercializationId ? n = i : '';
                };
                i++;
                k.SortOrder = i * 10;
                k.SortOriginal = i * 10;
            });

            //update model
            $scope.$evalAsync(function () {
                $timeout(function () {
                    model.setIndexId(n);
                    if (typeof $scope.focusElement !== 'undefined') {
                        $scope.focusElement.querySelectorAll('.focusInput')[0].focus();
                    }
                })
            });
        }

        $scope.startSortable = function (table) {
            var sortableTable = document.getElementById(table);
            if (sortableTable) {
                Sortable.create(sortableTable, {
                    handle: '.draggable',
                    animation: 150,
                    onEnd: function (evt) {
                        $scope.focusElement = undefined;
                        $scope.tableOrder(evt.newIndex, evt.oldIndex, evt.from.id);
                    }
                });
            }
        }

        $scope.tableOrderKey = function (event, $index, array) {
            //backspace, tab, up, down, left, right arrows, enter
            var allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46, 116];
            var allowedMetaKeys = [65, 86, 67, 88, 82, 90];
            //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
            var eventKey = event.key;

            //no spacebar
            if (eventKey == " ") {
                eventKey = 'x';
                //just defaulting it to a value that isnt allowed
            }

            if (isNaN(eventKey) && eventKey !== 'Tab') {
                //if ctrl isnt being pressed
                var ctrlMeta = event.ctrlKey == true || event.metaKey == true;
                if (ctrlMeta) {
                    //move to first
                    if (event.keyCode == 38) {
                        $scope.tableOrder(0, $index, array, null);
                        $scope.focusElement = event.path[3].children[0];
                    }
                    //move to last
                    if (event.keyCode == 40) {
                        $scope.tableOrder(array.length - 1, $index, array, null);
                        $scope.focusElement = event.path[3].children[array.length - 1];
                    }
                } else {
                    if (allowedKeys.indexOf(event.keyCode) == -1) {
                        event.preventDefault();
                    }
                    if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                        event.preventDefault();
                    }

                    //move up 1
                    if (event.keyCode == 38) {
                        if ($index !== 0) {
                            $scope.tableOrder($index - 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index - 1];
                        }
                    }

                    //move down 1
                    if (event.keyCode == 40) {
                        if ($index !== array.length - 1) {
                            $scope.tableOrder($index + 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index + 1];
                        }
                    }
                }
            }
        };

        //default sort order set to false (desc) so when you first click, its asc
        $scope.tableSortDir = '';
        $scope.tableSort = function (h) {
            if (h !== $scope.tableSortName) {
                //reset order direction if new name is chosen
                $scope.tableSortDir = '';
            }

            $scope.tableSortName = h;

            if ($scope.tableSortDir === '') { //first click
                $scope.tableSortDir = false
                $scope.tableSortClass = 'fa-caret-up';
            } else if ($scope.tableSortDir === false) { //second click
                $scope.tableSortDir = true
                $scope.tableSortClass = 'fa-caret-down';
            } else { //third click, reset it all
                $scope.tableSortDir = '';
                $scope.tableSortClass = '';
                $scope.tableSortName = '';
            }
        }

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        }

        model.getUser = function (scope, item) {
            //required because sometimes its an object with properties or a string
            var fullName = !item.ApprovedByName.length ? item.ApprovedByName.FullName.trim() : item.ApprovedByName.trim();
            if (fullName !== "") {
                UserService.getUserByNameandBrand(model.patternDetails.BrandId, fullName)
                    .then(function (response) {
                        if (response.Id != 0) {
                            item.ApprovedBy = response.Id;
                            scope.criticalPathCommercializationProcessesForm.accountable.$setValidity('accountableName', true);
                        }
                        else {
                            scope.criticalPathCommercializationProcessesForm.accountable.$setValidity('accountableName', false);
                        }
                    },
                        function (error, status) {
                            scope.criticalPathCommercializationProcessesForm.accountable.$setValidity('accountableName', false);
                        });
            } else {
                item.ApprovedBy = '';
            }
        }
        //getCriticalPathCommercializationDetails();

        $scope.replaceLineBreaks = function (v) {
            if (v) {
                var newValue = v.replace(/[\r\n]+/g, '\xa0\xa0');
                return newValue;
            }
        }

        //Check for duplicate critical path name
        model.checkCPName = function (scope) {
            //scope.criticalPathCommercializationEditForm.cpCommercializationName.$setValidity('criticalPathNameExists', true);
            var cpName = model.criticalPathCommercializationHeaderDetails.CriticalPathName;
            CriticalPathService.isCPCommercializationNameExists(model.criticalPathCommercializationId, cpName)
                .then(function (response) {
                    if (response == true) {
                        //scope.criticalPathCommercializationEditForm.cpCommercializationName.$setValidity('criticalPathNameExists', false);
                        toaster.pop({
                            type: 'note',
                            title: 'Name duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 5000
                        });
                    }
                });
        }

        model.addRow = function (idx, arr, a, t) {
            var item = {
                CriticalPathCommercializationProcessId: 0,
                ProcessName: "",
                EstStartDate: "",
                EstEndDate: "",
                RevStartDate: "",
                RevEndDate: "",
                Notes: "",
                Notes2: null,
                ProcessType: "DEF",
                CanChangeName: true,
                CanBeDeleted: true,
                CanEditRevCompleteDate: true,
                CanEditRevStartDate: true,
                CanEditStatus: true,
            };
            arr.splice(idx + a, 0, item);
            var e = document.getElementById(t)
            $scope.focusElement = e.children[idx + a];
            $scope.tableOrder(idx + a, false, arr, true);
        }

        //Delete row
        model.deleteRow = function (currentIndex, arr) {
            $scope.criticalPathCommercializationEditForm.$setDirty();
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                //mark row to delete from database only if process exists
                if (arr[currentIndex].CriticalPathCommercializationProcessId != 0) {
                    model.cpCommercializationProcessesToDelete.push({ CriticalPathCommercializationProcessId: arr[currentIndex].CriticalPathCommercializationProcessId });
                }
                arr.splice(currentIndex, 1);
            }
            $scope.tableOrder(currentIndex, false, arr);
        }

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        }

        //format string for date
        function formatString(format) {
            var day = parseInt(format.substring(3, 5));
            var month = parseInt(format.substring(0, 2));
            var year = parseInt(format.substring(6, 10));
            var date = new Date(year, month - 1, day);
            return date;
        }

        //Validate dates
        model.validateDates = function (scope, currentIndex, dateField, mode) {

            //est dates validation
            if (mode == 'est') {
                var estStartDate = $filter('date')($scope.criticalPathCommercializationProcesses[currentIndex].EstStartDate, "MM/dd/yyyy");
                var estEndDate = $filter('date')($scope.criticalPathCommercializationProcesses[currentIndex].EstEndDate, "MM/dd/yyyy");

                if (estStartDate && estEndDate) {
                    var date2 = new Date(formatString(estEndDate));
                    var date1 = new Date(formatString(estStartDate));

                    if (date2.getTime() - date1.getTime() >= 0) {
                        scope.criticalPathCommercializationProcessesForm.estStartDate.$setValidity('estSDate', true);
                        scope.criticalPathCommercializationProcessesForm.estEndDate.$setValidity('estEDate', true);
                    }
                    else {
                        if (dateField == 's') {
                            scope.criticalPathCommercializationProcessesForm.estStartDate.$setValidity('estSDate', false);
                        }
                        else if (dateField == 'e') {
                            scope.criticalPathCommercializationProcessesForm.estEndDate.$setValidity('estEDate', false);
                        }
                    }
                }
            }


            //rev dates validation
            if (mode == 'rev') {
                var revStartDate = $filter('date')($scope.criticalPathCommercializationProcesses[currentIndex].RevStartDate, "MM/dd/yyyy");
                var revEndDate = $filter('date')($scope.criticalPathCommercializationProcesses[currentIndex].RevEndDate, "MM/dd/yyyy");

                if (revStartDate && revEndDate) {
                    var date2 = new Date(formatString(revEndDate));
                    var date1 = new Date(formatString(revStartDate));

                    if (date2.getTime() - date1.getTime() >= 0) {
                        scope.criticalPathCommercializationProcessesForm.revStartDate.$setValidity('revSDate', true);
                        scope.criticalPathCommercializationProcessesForm.revEndDate.$setValidity('revEDate', true);
                    }
                    else {
                        if (dateField == 's') {
                            scope.criticalPathCommercializationProcessesForm.revStartDate.$setValidity('revSDate', false);
                        }
                        else if (dateField == 'e') {
                            scope.criticalPathCommercializationProcessesForm.revEndDate.$setValidity('revEDate', false);
                        }
                    }
                }
            }
        }

        //Set Approval Data
        model.setApprovalData = function (currentIndex) {
            if ($scope.criticalPathCommercializationProcesses[currentIndex].CriticalPathProcessApprovedId > 0) {
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovedByName = $rootScope.fullName;
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovalDate = $filter('date')(new Date(), 'MM/dd/yyyy');
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovedBy = $rootScope.userId;
            }
            else {
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovedByName = "";
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovalDate = "";
                $scope.criticalPathCommercializationProcesses[currentIndex].ApprovedBy = "";
            }
        }

        //Save Commercialization Header and Details
        model.Save = function (isFormInvalid) {

            if (!isFormInvalid) {
                $scope.criticalPathCommercializationEditForm.$setPristine();

                //Get Header Data
                model.criticalPathCommercializationData = {
                    CriticalPathCommercializationId: model.criticalPathCommercializationHeaderDetails.CriticalPathCommercializationId,
                    CriticalPathName: model.criticalPathCommercializationHeaderDetails.CriticalPathName,
                    CriticalPathHeaderStatusId: model.criticalPathCommercializationHeaderDetails.CriticalPathHeaderStatusId,
                    Notes: model.criticalPathCommercializationHeaderDetails.Notes
                }

                //Get Processes Data

                var getEstStartDate = "";
                var getEstEndDate = "";
                var getRevStartDate = "";
                var getRevEndDate = "";


                for (var i = 0; i < $scope.criticalPathCommercializationProcesses.length; i++) {
                    getEstStartDate = "";
                    getEstEndDate = "";
                    getRevStartDate = "";
                    getRevEndDate = "";

                    //Format Est dates
                    if ($scope.criticalPathCommercializationProcesses[i].EstStartDate) {
                        var estStartDate = new Date($scope.criticalPathCommercializationProcesses[i].EstStartDate);

                        // After this construct a string with the above results as below
                        getEstStartDate = $filter('date')(estStartDate, 'MM/dd/yyyy');
                    }


                    if ($scope.criticalPathCommercializationProcesses[i].EstEndDate) {
                        var estEndDate = new Date($scope.criticalPathCommercializationProcesses[i].EstEndDate);

                        // After this construct a string with the above results as below
                        getEstEndDate = $filter('date')(estEndDate, 'MM/dd/yyyy');
                    }

                    //Format Rev dates
                    if ($scope.criticalPathCommercializationProcesses[i].RevStartDate) {
                        var revStartDate = new Date($scope.criticalPathCommercializationProcesses[i].RevStartDate);

                        // After this construct a string with the above results as below
                        getRevStartDate = $filter('date')(revStartDate, 'MM/dd/yyyy');
                    }



                    if ($scope.criticalPathCommercializationProcesses[i].RevEndDate) {
                        var revEndDate = new Date($scope.criticalPathCommercializationProcesses[i].RevEndDate);

                        // After this construct a string with the above results as below
                        getRevEndDate = $filter('date')(revEndDate, 'MM/dd/yyyy');
                    }

                    model.cpCommercializationProcessesData.push({
                        CriticalPathCommercializationProcessId: $scope.criticalPathCommercializationProcesses[i].CriticalPathCommercializationProcessId,
                        CriticalPathCommercializationId: model.criticalPathCommercializationHeaderDetails.CriticalPathCommercializationId,
                        ProcessName: $filter('uppercase')($scope.criticalPathCommercializationProcesses[i].ProcessName),
                        ProcessType: $filter('uppercase')($scope.criticalPathCommercializationProcesses[i].ProcessType),
                        SortOrder: $scope.criticalPathCommercializationProcesses[i].SortOrder,
                        CanBeDeleted: $scope.criticalPathCommercializationProcesses[i].CanBeDeleted,
                        CanChangeName: $scope.criticalPathCommercializationProcesses[i].CanChangeName,
                        EstStartDate: getEstStartDate,
                        EstEndDate: getEstEndDate,
                        RevStartDate: getRevStartDate,
                        RevEndDate: getRevEndDate,
                        CriticalPathProcessApprovedId: $scope.criticalPathCommercializationProcesses[i].CriticalPathProcessApprovedId,
                        ApprovedBy: $scope.criticalPathCommercializationProcesses[i].ApprovedBy,
                        ApprovalDate: $filter('date')($scope.criticalPathCommercializationProcesses[i].ApprovalDate, 'short'),
                        IsDeleted: false,
                        Notes: $scope.criticalPathCommercializationProcesses[i].Notes
                    });
                }

                //Add Seasonal deleted rows to the list to delete from database
                for (var j = 0; j < model.cpCommercializationProcessesToDelete.length; j++) {
                    model.cpCommercializationProcessesData.push({
                        CriticalPathCommercializationProcessId: model.cpCommercializationProcessesToDelete[j].CriticalPathCommercializationProcessId,
                        CriticalPathCommercializationId: model.criticalPathCommercializationHeaderDetails.CriticalPathCommercializationId,
                        IsDeleted: true
                    });
                }

                CriticalPathService.updateCriticalPathCommercialization(model.criticalPathCommercializationData, model.cpCommercializationProcessesData)
                    .then(function (response) {
                        if (response.IsSuccessful) {
                            toaster.pop({ type: 'success', title: 'Success!', body: 'Record Saved Successfully.', timeout: 5000 });

                            model.cpCommercializationProcessesData = [];
                            model.cpCommercializationProcessesToDelete = [];
                            getCriticalPathCommercializationDetails();
                            getCriticalPathCommercializationProcesses();
                        }
                        else {
                            toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while saving the record. Please contact your system administrator', timeout: 5000 });
                        }

                        $scope.criticalPathCommercializationEditForm.$setPristine();
                        $scope.criticalPathCommercializationEditForm.$setUntouched();
                    }, function (error, status) {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while saving the record. Please contact your system administrator', timeout: 5000 });

                        $scope.criticalPathCommercializationEditForm.$setPristine();
                        $scope.criticalPathCommercializationEditForm.$setUntouched();
                    });

            }
            else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please review all fields indicated in red',
                    timeout: 5000
                });
            }
        }

        model.canCommercializationBeCanceled = function () {


            $scope.criticalPathCommercializationEditForm.$setValidity('criticalPathCannotBeCanceled', true);

            if (model.criticalPathCommercializationHeaderDetails.CriticalPathHeaderStatusId == 1) {
                CriticalPathService.canCommercializationBeCanceled(model.criticalPathCommercializationHeaderDetails.CriticalPathCommercializationId)
                    .then(function (response) {

                        if (response == false) {
                            $scope.criticalPathCommercializationEditForm.$setValidity('criticalPathCannotBeCanceled', false);
                        }
                    });
            }
        }

        //Go to Search Page
        model.Search = function () {
            $state.go("criticalPathIndex", { searchType: 3 });
        }

        model.Report = function () {
            $scope.criticalPathCommercializationEditForm.$setPristine();

            model.parameterValues = [];

            //set Report Parameters
            model.parameterValues.push(model.criticalPathCommercializationId);

            var reportName = 'CommercializationCriticalPath';
            var parameterName = 'CriticalPathCommercializationId'
            var parameterValuesList = JSON.stringify(model.parameterValues);

            ReportService.generateReport(reportName, parameterName, parameterValuesList).then(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                saveAs(file, reportName + '.pdf')

            }, function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error generating the report. Please contact your system administrator.',
                    timeout: 5000
                });
            });

        }
    }
})();
